export type AuthUrlResponse = {
  auth_url: string;
}

export type UserInfoResponse = {
  id: number;
  name: string;
  email: string;
  groups: string[];
  roles: string[];
  prefs: Record<string, any>;
}

export function useAuthApi() {
  const fetch = useMoriaFetch();

  function getAuthUrl() {
    return fetch<AuthUrlResponse>('/auth/login', { immediate: false }).json();
  }

  function getUserInfo() {
    return fetch<UserInfoResponse>('/auth/userinfo', {
      immediate: false
    }).json()
  }

  function processCallback(code: string) {
    return fetch('/auth/callback', {
      method: 'POST',
      body: JSON.stringify({ code }),
    });
  }

  function logout() {
    return fetch('/auth/logout', {
      method: 'POST',
    });
  }

  return { getAuthUrl, getUserInfo, processCallback, logout };
}
